import type { VoiceMessage } from "./types"

export function hasUnheardVoice(
	voiceMessage: VoiceMessage | undefined,
	friendId: number,
): boolean {
	return voiceMessage?.phase === "ready" && voiceMessage.author_id === friendId
}
